import { Check, RotateCcw } from 'lucide-react';
import { Button } from '../ui/button';
import { BACKGROUNDS, DEFAULT_PREFERENCES, EAGLE_STYLES, SPEEDS } from './preferences';

export const EagleAppearanceFields = ({ preferences, onChange, saveError, idPrefix = 'home-eagle' }) => <>
  <fieldset><legend className="text-xs font-semibold mb-2">Animation style</legend>
    <div className="home-eagle-style-options" role="group" aria-label="Eagle animation style" data-testid={`${idPrefix}-styles`}>
      {EAGLE_STYLES.map(style => <button type="button" key={style.value} data-testid={`${idPrefix}-style-${style.value}`}
        aria-pressed={preferences.eagleStyle === style.value} onClick={() => onChange({ eagleStyle: style.value })}>{style.label}</button>)}
    </div>
  </fieldset>
  <fieldset><legend className="text-xs font-semibold mb-2">Background</legend>
    <div className="flex flex-wrap items-center justify-between gap-2" role="group" aria-label="Animation background" data-testid={`${idPrefix}-backgrounds`}>
      {BACKGROUNDS.map((option, index) => <button type="button" key={option.value}
        data-testid={`${idPrefix}-background-${index}`} className={`home-eagle-swatch${index === 0 ? ' home-eagle-transparent' : ''}`}
        style={option.color ? { backgroundColor: option.color } : undefined} aria-label={option.label} title={option.label}
        aria-pressed={preferences.background.toLowerCase() === option.value} onClick={() => onChange({ background: option.value })}>
        {preferences.background.toLowerCase() === option.value && <Check size={13} aria-hidden="true" style={{ color: option.value === '#172521' ? '#fff' : '#172521' }} />}
      </button>)}
    </div>
    <label htmlFor={`${idPrefix}-custom-color`} className="mt-3 flex items-center justify-between text-xs">
      Custom color<input id={`${idPrefix}-custom-color`} data-testid={`${idPrefix}-custom-color`} type="color"
        className="home-eagle-color-input" value={preferences.background === 'transparent' ? '#e7f4ed' : preferences.background}
        onChange={event => onChange({ background: event.target.value })} />
    </label>
  </fieldset>
  <fieldset><legend className="text-xs font-semibold mb-2">Loop speed</legend>
    <div className="home-eagle-speed-options" role="group" aria-label="Animation speed" data-testid={`${idPrefix}-speeds`}>
      {SPEEDS.map(speed => <button type="button" key={speed} data-testid={`${idPrefix}-speed-${speed}`}
        aria-pressed={preferences.speed === speed} onClick={() => onChange({ speed })}>{speed}×</button>)}
    </div>
  </fieldset>
  {saveError && <p role="status" className="text-xs" data-testid={`${idPrefix}-save-error`}>Changes apply now, but could not be saved on this device.</p>}
  <Button type="button" variant="ghost" className="h-8 text-xs" data-testid={`${idPrefix}-reset`} onClick={() => onChange(DEFAULT_PREFERENCES)}>
    <RotateCcw size={13} className="mr-2" />Reset appearance
  </Button>
</>;